// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  statistic: {
    root: path(ROOTS_DASHBOARD, '/statistic'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/user/${id}/edit`),
  },
  partner: {
    root: path(ROOTS_DASHBOARD, '/partner'),
    new: path(ROOTS_DASHBOARD, '/partner/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/partner/${id}/edit`),
  },
  order: {
    root: path(ROOTS_DASHBOARD, '/order'),
    view: (id) => path(ROOTS_DASHBOARD, `/order/${id}`),
  },
  bankCard: {
    root: path(ROOTS_DASHBOARD, '/bank-card/list'),
    new: path(ROOTS_DASHBOARD, '/bank-card/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/bank-card/${id}/view`),
    productions: path(ROOTS_DASHBOARD, '/bank-card/production'),
    addPending: path(ROOTS_DASHBOARD, '/bank-card/add-pending'),
  },
  payment: {
    root: path(ROOTS_DASHBOARD, '/payment'),
    newLink: path(ROOTS_DASHBOARD, '/payment/new-link'),
  },
  delivery: {
    root: path(ROOTS_DASHBOARD, '/settings/delivery'),
  },
  userRequest: {
    root: path(ROOTS_DASHBOARD, '/request'),
    view: (id) => path(ROOTS_DASHBOARD, `/request/${id}`),
  },
  withdrawal: {
    root: path(ROOTS_DASHBOARD, '/withdrawal'),
    view: (id) => path(ROOTS_DASHBOARD, `/withdrawal/${id}`),
  },
  exchange: {
    root: path(ROOTS_DASHBOARD, '/settings/exchange'),
  },
  gateway: {
    root: path(ROOTS_DASHBOARD, '/settings/gateway'),
  },
  wallet: {
    root: path(ROOTS_DASHBOARD, '/wallet-list'),
  },
  walletHistory: {
    root: path(ROOTS_DASHBOARD, '/wallet-history'),
  },
  setting: {
    root: path(ROOTS_DASHBOARD, '/settings/general'),
  },
  terminal: {
    root: path(ROOTS_DASHBOARD, '/settings/terminal'),
  },
  discountCoupon: {
    root: path(ROOTS_DASHBOARD, '/discount-coupon/list'),
    new: path(ROOTS_DASHBOARD, '/discount-coupon/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/discount-coupon/${id}/edit`),
  },
  ticket: {
    root: path(ROOTS_DASHBOARD, '/ticket/list'),
    new: path(ROOTS_DASHBOARD, '/ticket/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/ticket/${id}/view`),
  },
  redeemCode: {
    root: path(ROOTS_DASHBOARD, '/redeem-code/list'),
  },
  cardRequests: {
    root: path(ROOTS_DASHBOARD, '/card-requests'),
  },
  chargeRequests: {
    root: path(ROOTS_DASHBOARD, '/charge-requests'),
  },
  plans: {
    root: path(ROOTS_DASHBOARD, '/settings/plans'),
  },
  userKycForm: {
    root: path(ROOTS_DASHBOARD, '/kyc-requests'),
    view: (id) => path(ROOTS_DASHBOARD, `/kyc-requests/${id}`),
  },
  addressRequests: {
    root: path(ROOTS_DASHBOARD, '/address-requests'),
  },
  userAddressForm: {
    root: path(ROOTS_DASHBOARD, '/address-requests'),
    view: (id) => path(ROOTS_DASHBOARD, `/address-requests/${id}`),
  },
  topup: {
    root: path(ROOTS_DASHBOARD, '/topup'),
    view: (id) => path(ROOTS_DASHBOARD, `/topup/${id}`),
  },
};
